import React, { useEffect } from "react";
import { Container} from "@mui/material";
import SigninForm from "../../components/SigninForm";
import Logo from "../../components/Logo";
import { motion } from "framer-motion";
import "./style.css";

let easing = [0.6, -0.05, 0.01, 0.99];
const fadeInUp = {
  initial: {
    y: 60,
    opacity: 0,
    transition: { duration: 0.6, ease: easing },
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: easing,
    },
  },
};

function getSystemTheme() {
  try {
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    return mq && mq.matches ? "dark" : "light";
  } catch {
    return "light";
  }
}

function getInitialTheme() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get("theme"); 
    if (fromUrl === "dark" || fromUrl === "light") return fromUrl;
    return getSystemTheme();
  } catch {
    return "light";
  }
}

function applyTheme(theme) {
  const next = theme === "dark" ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", next);
}

const Login = ({ setAuth }) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const override = params.get("theme");

    applyTheme(getInitialTheme());

    if (!override || override === "system") {
      const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
      const handler = (e) => applyTheme(e.matches ? "dark" : "light");
      if (mq) {
        if (mq.addEventListener) mq.addEventListener("change", handler);
        else if (mq.addListener) mq.addListener(handler); 
        return () => {
          if (mq.removeEventListener) mq.removeEventListener("change", handler);
          else if (mq.removeListener) mq.removeListener(handler);
        };
      }
    }
  }, []);


  return (
    <div className="root">
      <Container className="container" maxWidth="sm">
        <div className="card-content">    
          <div className="sub-content">
            <div className="heading" component={motion.div} {...fadeInUp}>
              <Logo />
            </div>

            <SigninForm setAuth={setAuth} />
            
            {/* Commented until fixed the internal redirect back to app */}
            {/* <Typography
              component={motion.p}
              {...fadeInUp}
              variant="body2"
              align="center"
              className="footer-text"
            >
              Need an account?{" "}
              <Link
                variant="subtitle2"
                component={RouterLink}
                to="/signup"
                style={{ color: "#00C56E" }}
              >
                Sign up
              </Link>
            </Typography> */}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Login;
